<template>
  <section class="mt-2">
    <b-button @click="saveBtn">SAVE</b-button>


  </section>
</template>
<script>
export default {
  data() {
    return {
      url: process.env.VUE_APP_URL,
      context: {},
      channel: '',
      team: '',
      locale: '',
      params: {}
    };
  },
  methods: {
    saveBtn() {
      let self = this;
      this.microsoftTeams.settings.setValidityState(true);
      this.microsoftTeams.settings.registerOnSaveHandler(function(saveEvent){
          self.microsoftTeams.settings.setSettings({
              websiteUrl: process.env.VUE_APP_URL,
              contentUrl: process.env.VUE_APP_URL + "/messages",
              entityId: "sefosMessages",
              suggestedDisplayName: "SEFOS Messages"
          });
          saveEvent.notifySuccess();
      });
    }
  },
  computed: {
  },
  mounted() {
    let self = this;
    let urlParams = new URLSearchParams(document.location.search.substring(1));
    this.loading = true;
    this.params = urlParams;
    this.channel = urlParams.get("channel");
    this.team = urlParams.get("team");
    this.locale = urlParams.get("locale");
    this.microsoft.app.getContext(function(context)
        {
          self.context = context;
        });
  },
};
</script>
<style></style>
